/**
 * Get the site URL for auth redirects
 * 
 * In client-side code: Always uses window.location.origin (automatically correct)
 * In server-side code: Uses NEXT_PUBLIC_SITE_URL env var with production fallback
 * 
 * This ensures:
 * - Production: Always uses the actual deployed origin (https://www.offaxisdeals.com)
 * - Development: Uses localhost:3000 (or whatever dev server is running)
 * - No hardcoded localhost in production
 */
export function getSiteUrl(): string {
  // Client-side: use window.location.origin (always correct for current environment)
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  // Server-side: use env var with production fallback
  return process.env.NEXT_PUBLIC_SITE_URL || 'https://www.offaxisdeals.com';
}
